import React, { useEffect, useState } from 'react';
import { Card, Typography, Divider } from 'antd';
import axios from 'axios';

const { Title, Text } = Typography;

const AccountInfo: React.FC = () => {
  let userInfo: any = localStorage.getItem('User');
  if (userInfo) userInfo = JSON.parse(userInfo);

  const [additionalUserInfo, setAdditionalUserInfo] = useState<any>();

  useEffect(() => {
    if (userInfo)
      axios
        .get(`${process.env.REACT_APP_INSTANCE}/api/user/${userInfo.email}`)
        .then(res => {
          setAdditionalUserInfo(res.data);
        });
  }, []);

  return (
    <Card
      style={{
        maxWidth: '100%',
        width: '100%',
        margin: '0 auto',
        padding: '20px',
        backgroundColor: '#fff',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        borderRadius: '8px',
        overflowX: 'hidden'
      }}
    >
      <div style={{ textAlign: 'left' }}>
        <Title level={4} style={{ textAlign: 'left' }}>
          User
        </Title>
        <Divider />
        <div style={{ marginBottom: '20px', textAlign: 'left' }}>
          <Title level={5} style={{ textAlign: 'left' }}>
            Name
          </Title>
          <Text>
            {userInfo?.name ||
              `${additionalUserInfo?.firstName || ''} ${
                additionalUserInfo?.lastName || ''
              }`}
          </Text>
        </div>
        <div style={{ marginBottom: '20px', textAlign: 'left' }}>
          <Title level={5} style={{ textAlign: 'left' }}>
            Email
          </Title>
          <Text>{userInfo?.email}</Text>
        </div>
      </div>
    </Card>
  );
};

export default AccountInfo;
